import { Game, generateGameShareURL, generateGameShareText } from '@/types/game'
import { toastManager } from '@/lib/toastManager'

export const shareGame = async (game: Game) => {
  const shareURL = generateGameShareURL(game)
  const shareText = generateGameShareText(game)
  const fullText = `${shareText}\n\n🔗 Link: ${shareURL}`
  
  try {
    await navigator.clipboard.writeText(fullText)
    toastManager.success('📋 Jogo copiado! Cole onde quiser compartilhar.')
  } catch (error) {
    console.error('Erro ao copiar:', error)
    // Fallback para browsers mais antigos
    const textArea = document.createElement('textarea')
    textArea.value = fullText
    document.body.appendChild(textArea)
    textArea.select()
    try {
      document.execCommand('copy')
      toastManager.success('📋 Jogo copiado! Cole onde quiser compartilhar.')
    } catch (fallbackError) {
      console.error('Fallback copy failed:', fallbackError)
      alert(`Compartilhe este jogo:\n\n${fullText}`)
    }
    document.body.removeChild(textArea)
  }
}